module.exports = __webpack_public_path__ + "static/media/video3-brisbane.9755b236.mp4";